import React, { useCallback, useEffect, useContext, useState } from 'react'
import LazyLoad, { forceCheck } from 'react-lazyload'
import { MainContext } from "../../context/mainContext";
import { HeroBanner } from './heroBanner'
import { UpcomingEvents } from './upcomingEvents'
import { CatalogList } from './catalogList'
import { TopSellers } from './topSellers'
import { SingleBanner } from './singleBanner'
import { VideoHero } from './videoHero'
import { CardSection } from './cardSection'
import { Seals } from "./seals"
import { OlapicList } from './olapicList'
import { Combo } from './combo'
import { SalesRepsV2 } from './salesRepsV2';
import { MarqueeBanner } from '../../components/MarqueeBanner/MarqueeBanner';
import { useGoogleAnalyticsHandler } from '../../hooks'

export const HomePage = ({ appData }) => {
	const ctx = useContext(MainContext)
	const catalogsQty = appData.storedata?.productCatalogs?.length
	const isTryOn = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreTryOn") && appData.storedata?.schoolStoreTryOn?.tryOnBannerUrl)
	const isUnderclassmenEssentials = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreUnderclassmenEssentials") && appData.storedata?.schoolStoreRingSizer?.hasUnderclassmenEssentialsBanner)
	const hasCardBannerSection = Boolean(isTryOn || isUnderclassmenEssentials)
	const isEvents = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolEvents"))
	const isTopSellers = Boolean(appData.customerdata?.find(data => data.contentType === "ProductTopSellers"))
	const isReps = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreReps"))
	const isOlapic = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreOlapic"))
	const isSeal = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreSeal"))
	const isVideo = Boolean(appData.customerdata?.find(data => data.contentType === "MediaCallout"))
	const isBannerSection = Boolean(appData.customerdata?.find(data => data.contentType === "BannerSection"))

	const googleAnalytics = useGoogleAnalyticsHandler({
		customerNumber: appData.affiliationdata?.customerNumber,
		catalogOsrList: appData.storedata?.productCatalogs?.reduce((catalogOsrs, catalog) => {
			const subCatalogOsrList = catalog.subCatalogs?.reduce((subCatalogOsrs, subCatalog)=> {
				return [...subCatalogOsrs, subCatalog.catalogOsr]
			}, []) || [];
			
			return [...catalogOsrs, catalog.catalogOsr, ...subCatalogOsrList]
		}, [])
	})

	const [loadGrid, setLoadGrid] = useState(false)
	const handleScroll = () => {
		setLoadGrid(true);
		removeScrollEvent();
	};
	const addScrollEvent = () => {
		window.addEventListener('scroll', handleScroll);
	}
	const removeScrollEvent = () => {
		window.removeEventListener('scroll', handleScroll);
	}
	
	useEffect(()=>{
		if(document.body.clientWidth<1980) {
			addScrollEvent();
		} else {
			setLoadGrid(true);
		}
		return () => removeScrollEvent();
	},[])

	const linkOnClickHandler = useCallback(
		() => {
			ctx.setLoading(true)
		},
		[],
	)

	useEffect(() => {
		const setSitemap = setTimeout(()=>{
			forceCheck()
			const cLinks = document.querySelectorAll('.footer-link>a')
			const siteMap = document.querySelector('a[href="/site-map"]')
			siteMap && siteMap.setAttribute('href', '/apps/store/sitemap/-/-/')
			cLinks.forEach(link => {
				link.addEventListener('click', linkOnClickHandler, false);
			});
		}, 1500)
		return ()=>{clearTimeout(setSitemap)}
	}, [])

	return (
		<>
			<MarqueeBanner appData={appData} />
			<HeroBanner appData={appData} />

			{ isEvents && <UpcomingEvents appData={appData} /> }

			{
				((!hasCardBannerSection) || catalogsQty >= 3 || !catalogsQty) &&
					<LazyLoad offset={100} height={500} once resize>
						<CatalogList appData={appData} googleAnalytics={googleAnalytics} />
					</LazyLoad>
			}

			{
				((hasCardBannerSection) && (catalogsQty === 1 || catalogsQty === 2)) &&
					<LazyLoad offset={100} height={500} once >
						<Combo appData={appData} googleAnalytics={googleAnalytics} />
					</LazyLoad>
			}

			{isTopSellers && loadGrid &&
			<LazyLoad offset={100} height={500} once resize>
				<TopSellers appData={appData} />
			</LazyLoad>}

			{isBannerSection && loadGrid &&
			<LazyLoad offset={100} height={500} once>
				<SingleBanner appData={appData} />
			</LazyLoad>}

			{isVideo && loadGrid &&
			<LazyLoad offset={100} height={500} once>
				<VideoHero appData={appData} />
			</LazyLoad>}

			{
				((hasCardBannerSection) && (catalogsQty === 0 || catalogsQty >= 3)) &&
					<LazyLoad offset={100} height={500} once>
						<CardSection appData={appData} googleAnalytics={googleAnalytics} />
					</LazyLoad>
			}

			{isReps && loadGrid &&
			<div id="salesRep">
				<LazyLoad offset={100} height={500} once>
					<SalesRepsV2 appData={appData} />
				</LazyLoad>
			</div>}

			{isSeal && loadGrid &&
			<LazyLoad offset={100} height={500} once>
				<Seals appData={appData} />
			</LazyLoad>}

			{isOlapic && loadGrid &&
			<LazyLoad offset={100} height={500} once>
				<OlapicList appData={appData} />
			</LazyLoad>}
		{/* </Suspense> */}
		</>
	)
}
